import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CommunicationPreferencesMatrixComponent } from '../communication-preferences-matrix/communication-preferences-matrix.component';

@Component({
    selector: 'app-communication-preferences-popup',
        standalone: true,
imports: [CommunicationPreferencesMatrixComponent,
        TranslatePipe
    ],
    templateUrl: './communication-preferences-popup.component.html',
    styleUrl: './communication-preferences-popup.component.scss'
})
export class CommunicationPreferencesPopupComponent {
  constructor(
    private dialogRef: MatDialogRef<CommunicationPreferencesPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Prevent dialog from being closed by any means
    this.dialogRef.disableClose = true;
  }
}
